import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import Media from 'react-media';
import styled from '@emotion/styled';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Icon from '~/core/scripts/components/Icon';
import CoronaMap from '~/scripts/components/Map';
import { getFilterFn, getMapFilterFn } from '~/scripts/utils';
import CasesDisplay from './TeaserCasesDisplay';

import { MapHeightHolder } from '~/css-in-js/map.styles';

const Wrapper = styled.div`
  margin: 5px 5px 10px 5px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  border: 1px solid ${(p) => p.theme.colors.grey95};
  border-width: 1px 1px 0 1px;
  overflow: hidden;
  min-height: 250px;
  display: flex;
  flex-direction: column;

  ${(p) => p.theme.breakpoints.sm.up} {
    flex-direction: row;
  }

  &:hover {
    transition: box-shadow 0.5s;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
  }
`;

const CasesDisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${(p) => p.theme.breakpoints.sm.up} {
    flex-basis: 270px;
  }
`;

const MapWrapper = styled.div`
  ${(p) => p.theme.breakpoints.sm.up} {
    flex-basis: calc(100% - 270px);
  }
`;

const LinkWrapper = styled.div`
  background: #e0e9f4;
  padding: 12px;
  position: relative;
  font-size: 14px;
`;

const Link = styled.a`
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: all;
    cursor: pointer;
  }
  &:hover,
  &:active,
  &:focus,
  &:visited {
    opacity: 0.9;
  }
`;

const TeaserLink = () => {
  const appUrl = `${ARTICLE_CONFIG.baseUrl}/${ARTICLE_CONFIG.projectName}`;

  return (
    <LinkWrapper>
      <Link href={appUrl} target="_parent">
        <strong>Alle Fälle in Deutschland, Europa und weltweit</strong>
        <div>
          im Coronavirus-Monitor{' '}
          <Icon style={{ transform: 'rotate(180deg)' }} type="arrow-left"></Icon>
        </div>
      </Link>
    </LinkWrapper>
  );
};

const mapAttribution =
  'Karte: <a href="https://openmaptiles.org/" target="_blank" rel="noreferrer">© OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">© OpenStreetMap contributors</a>';

const maxWidth = 599;
const minWidth = maxWidth + 1;
const queryDesktop = { minWidth };
const queryMobile = { maxWidth };

const CoronaTeaser = () => {
  const data = useStoreState((state) => state.data.current);
  const loadData = useStoreActions((actions) => actions.data.loadData);

  const filteredData = data.filter(getFilterFn('germany'));
  const worldData = data.filter(getFilterFn('world'));
  const mapData = data.filter(getMapFilterFn('germany'));

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Wrapper>
      <CasesDisplayWrapper>
        <CasesDisplay data={filteredData} originalData={worldData} />
        <Media query={queryDesktop}>
          <TeaserLink />
        </Media>
      </CasesDisplayWrapper>
      <MapWrapper id="iframeteaser__map">
        <MapHeightHolder mobileHeight={250} desktopHeight={350}>
          <CoronaMap
            mapAttribution={mapAttribution}
            attributionPrefix="Leaflet"
            data={mapData}
            bbox={[
              [43.068888, -11.030273],
              [58.240164, 30.827637],
            ]}
          />
        </MapHeightHolder>
      </MapWrapper>
      <Media query={queryMobile}>
        <TeaserLink />
      </Media>
    </Wrapper>
  );
};

export default hot(CoronaTeaser);
